import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
/** Native modal: mount to open, unmount to close. No styles or app services. */
export function Dialog({ titleId, onClose, children, className = '' }) {
    const ref = useRef(null);
    const closeRef = useRef(onClose);
    closeRef.current = onClose;
    useEffect(() => {
        const dialog = ref.current;
        const previous = document.activeElement;
        dialog?.showModal();
        return () => {
            dialog?.close();
            previous?.focus();
        };
    }, []);
    return (_jsx("dialog", { ref: ref, "aria-labelledby": titleId, className: className, onCancel: event => { event.preventDefault(); closeRef.current(); }, children: children }));
}
